module.exports = __webpack_public_path__ + "img/devoluciones-icon.aefb841f.png";